import { render, staticRenderFns } from "./FixTxListPanel.vue?vue&type=template&id=49968710&"
import script from "./FixTxListPanel.vue?vue&type=script&lang=js&"
export * from "./FixTxListPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports